export default __webpack_public_path__ + "static/media/f.f90aa281.jpg";